import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { AuthenticationService } from '../../shared/services/authentication.service';
// Import navigation elements
import { navigation } from './../../_nav';

@Component({
  selector: 'app-sidebar-nav',
  template: `
    <nav class="sidebar-nav">
      <ul class="nav">
        <ng-template ngFor let-navitem [ngForOf]="navigation">
          <li *ngIf="isDivider(navitem)" class="nav-divider"></li>
          <ng-template [ngIf]="isTitle(navitem)">
            <app-sidebar-nav-title [title]='navitem'></app-sidebar-nav-title>
          </ng-template>
          <ng-template [ngIf]="!isDivider(navitem)&&!isTitle(navitem)">
            <app-sidebar-nav-item [item]='navitem'></app-sidebar-nav-item>
          </ng-template>
        </ng-template>
      </ul>
    </nav>`
})
export class AppSidebarNavComponent {

  public navigation = navigation;



  public isDivider(item) {
    return item.divider ? true : false
  }

  public isTitle(item) {
    return item.title ? true : false
  }

  constructor() { }
}

import { Router } from '@angular/router';

@Component({
  selector: 'app-sidebar-nav-item',
  template: `
    <li *ngIf="!isDropdown(); else dropdown" [ngClass]="hasClass() ? 'nav-item ' + item.class : 'nav-item'">
      <app-sidebar-nav-link [link]='item'></app-sidebar-nav-link>
    </li>
    <ng-template #dropdown>
      <li *ngIf="havingPermission()" [ngClass]="hasClass() ? 'nav-item nav-dropdown ' + item.class : 'nav-item nav-dropdown'"
          [class.open]="isActive()"
          routerLinkActive="open"
          appNavDropdown>
        <app-sidebar-nav-dropdown [link]='item'></app-sidebar-nav-dropdown>
      </li>
    </ng-template>
    `
})
export class AppSidebarNavItemComponent {
  @Input() item: any;

  public hasClass() {
    return this.item.class ? true : false
  }

  public isDropdown() {
    return this.item.children ? true : false
  }

  public havingPermission() {
    // console.log(this.item);
    if (this.item.name == 'Payment') {
      if (this.authenticationService.permissions.indexOf('Manage Payment Collection') != -1 ||
        this.authenticationService.permissions.indexOf('Payment Conformation') != -1 ||
        this.authenticationService.permissions.indexOf('Product Sell History') != -1 ||
        this.authenticationService.permissions.indexOf('Manage Payment Deposition') != -1) {
        return true;
      } else {
        return false;
      }
    } else if (this.item.name === 'Report') {
      if (this.authenticationService.permissions.indexOf('Account Management Activity Management') != -1 ||
        this.authenticationService.permissions.indexOf('Lead Activity Management') != -1) {
        return true;
      } else {
        return false;
      }
    } else if (this.item.name === 'Settings') {
      if (this.authenticationService.permissions.indexOf('Goal Management') != -1 ||
        this.authenticationService.permissions.indexOf('City Management') != -1 ||
        this.authenticationService.permissions.indexOf('Holiday Management') != -1 ||
        this.authenticationService.permissions.indexOf('Role Management') != -1 ||
        this.authenticationService.permissions.indexOf('Change Owner') != -1) {
        return true;
      } else {
        return false;
      }
    }
  }
  public thisUrl() {
    return this.item.url
  }

  public isActive() {
    return this.router.isActive(this.thisUrl(), false)
  }

  constructor(private router: Router, public authenticationService: AuthenticationService) { }

}

@Component({
  selector: 'app-sidebar-nav-link',
  template: `
    <a *ngIf="havingPermission() && !isExternalLink(); else external"
      [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'"
      routerLinkActive="active"
      style="font-size: 13px;"
      [routerLink]="[link.url]">
      <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
      {{ link.name }}
      <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
    </a>
    <ng-template #external>
      <a *ngIf="havingPermission()" [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'" href="{{link.url}}">
        <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
        {{ link.name }}
        <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
      </a>
    </ng-template>
  `
})
export class AppSidebarNavLinkComponent {
  @Input() link: any;

  public hasVariant() {
    return this.link.variant ? true : false
  }

  public havingPermission() {
    // console.log(this.link.name);
    if (this.link.name == 'Dashboard') {
      // console.log('dashbord >>> '+this.authenticationService.permissions.indexOf('Common Dashboard'));
      return this.authenticationService.permissions.indexOf('Common Dashboard') != -1 ? true : false;
    } else if (this.link.name == 'Admin Dashboard') {
      // console.log('Admin Dashboard >>> '+this.authenticationService.permissions.indexOf('Admin Dashboard'));
      return this.authenticationService.permissions.indexOf('Admin Dashboard') != -1 ? true : false;
    } else if (this.link.name == 'Manage Users') {
      // console.log('Admin Dashboard >>> '+this.authenticationService.permissions.indexOf('Admin Dashboard'));
      if (this.authenticationService.permissions.indexOf('View Manage Users') != -1) {
        return true;
      } else {
        return false;
      }
    } else if (this.link.name == 'Manage Users') {
      // console.log('Admin Dashboard >>> '+this.authenticationService.permissions.indexOf('Admin Dashboard'));
      if (this.authenticationService.permissions.indexOf('Delete User') != -1 ||
        this.authenticationService.permissions.indexOf('Alter User Credit') != -1 ||
        this.authenticationService.permissions.indexOf('Add User') != -1 ||
        this.authenticationService.permissions.indexOf('Edit User') != -1 ||
        this.authenticationService.permissions.indexOf('Alter Group Credit') != -1
      ) {
        return true;
      } else {
        return false
      }

    } else if (this.link.name == 'Lead') {
      if (this.authenticationService.permissions.indexOf('Add Lead') != -1 ||
        this.authenticationService.permissions.indexOf('Assign Lead') != -1 ||
        this.authenticationService.permissions.indexOf('Closure Lead') != -1 ||
        this.authenticationService.permissions.indexOf('Delete Lead') != -1 ||
        this.authenticationService.permissions.indexOf('Edit Lead') != -1 ||
        this.authenticationService.permissions.indexOf('Open Lead') != -1 ||
        this.authenticationService.permissions.indexOf('NotInterest Lead') != -1
      ) {
        return true;
      } else {
        return false;
      }

    } else if (this.link.name == 'Account Management') {
      if (this.authenticationService.permissions.indexOf('Add Account Management') != -1 ||
        this.authenticationService.permissions.indexOf('Assign Account Management') != -1 ||
        this.authenticationService.permissions.indexOf('Closure Account Management') != -1 ||
        this.authenticationService.permissions.indexOf('Delete Account Management') != -1 ||
        this.authenticationService.permissions.indexOf('Edit Account Management') != -1 ||
        this.authenticationService.permissions.indexOf('Open Account Management') != -1 ||
        this.authenticationService.permissions.indexOf('Not Interest Account Management') != -1
      ) {
        return true;
      } else {
        return false;
      }

    } else if (this.link.name == 'Product') {
      if (this.authenticationService.permissions.indexOf('Add Product') != -1 ||
        this.authenticationService.permissions.indexOf('Delete Product') != -1 ||
        this.authenticationService.permissions.indexOf('Update Product') != -1
      ) {
        return true;
      } else {
        return false;
      }

    } else if (this.link.name == 'Admin Report') {
      if (this.authenticationService.permissions.indexOf('Admin Report') != -1) {
        return true;
      } else {
        return false;
      }

    } else if (this.link.name == 'Holiday') {
      if (this.authenticationService.permissions.indexOf('Holiday Management') != -1) {
        return true;
      } else {
        return false;
      }

    } else if (this.link.name == 'Goal') {
      if (this.authenticationService.permissions.indexOf('Goal Management') != -1) {
        return true;
      } else {
        return false;
      }

    } else if (this.link.name == 'Change Owner') {
      if (this.authenticationService.permissions.indexOf('Change Owner') != -1) {
        return true;
      } else {
        return false;
      }

    } else if (this.link.name == 'Role') {
      if (this.authenticationService.permissions.indexOf('Role Management') != -1) {
        return true;
      } else {
        return false;
      }

    } else if (this.link.name == 'City') {
      if (this.authenticationService.permissions.indexOf('City Management') != -1) {
        return true;
      } else {
        return false;
      }

    } else if (this.link.name == 'A/C Mgmt Activity') {
      if (this.authenticationService.permissions.indexOf('Account Management Activity Management') != -1) {
        return true;
      } else {
        return false;
      }

    } else if (this.link.name == 'Lead Activity') {
      if (this.authenticationService.permissions.indexOf('Lead Activity Management') != -1) {
        return true;
      } else {
        return false;
      }

    } else if (this.link.name == 'Payment Deposition') {
      if (this.authenticationService.permissions.indexOf('Manage Payment Deposition') != -1 ||
        this.authenticationService.permissions.indexOf('Payment Conformation') != -1) {
        return true;
      } else {
        return false;
      }

    } else if (this.link.name == 'Payment Collection') {
      if (this.authenticationService.permissions.indexOf('Manage Payment Collection') != -1) {
        return true;
      } else {
        return false;
      }

    } else if (this.link.name == 'Product Sell History') {
      if (this.authenticationService.permissions.indexOf('Product Sell History') != -1) {
        return true;
      } else {
        return false;
      }
    } else if (this.link.name == 'Complain Mgmt') {
      if (this.authenticationService.permissions.indexOf('Closure Complain/Suggestion') != -1 ||
        this.authenticationService.permissions.indexOf('Developer') != -1) {
        return true;
      } else {
        return false;
      }
    } else {
      // console.log(this.link.name);
     // console.log('permission', this.authenticationService.permissions);
    //  console.log("else")
      return false;
    }
  }

  public isBadge() {
    return this.link.badge ? true : false
  }

  public isExternalLink() {
    return this.link.url.substring(0, 4) === 'http' ? true : false
  }

  public isIcon() {
    return this.link.icon ? true : false
  }

  constructor(public authenticationService: AuthenticationService) {

  }
}

@Component({
  selector: 'app-sidebar-nav-dropdown',
  template: `
    <a class="nav-link nav-dropdown-toggle" appNavDropdownToggle>
      <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
      {{ link.name }}
      <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
    </a>
    <ul class="nav-dropdown-items">
      <ng-template ngFor let-child [ngForOf]="link.children">
        <app-sidebar-nav-item [item]='child'></app-sidebar-nav-item>
      </ng-template>
    </ul>
  `
})
export class AppSidebarNavDropdownComponent {
  @Input() link: any;

  public isBadge() {
    return this.link.badge ? true : false
  }

  public isIcon() {
    return this.link.icon ? true : false
  }

  constructor() { }
}

@Component({
  selector: 'app-sidebar-nav-title',
  template: ''
})
export class AppSidebarNavTitleComponent implements OnInit {
  @Input() title: any;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    const nativeElement: HTMLElement = this.el.nativeElement;
    const li = this.renderer.createElement('li');
    const name = this.renderer.createText(this.title.name);

    this.renderer.addClass(li, 'nav-title');

    if (this.title.class) {
      const classes = this.title.class;
      this.renderer.addClass(li, classes);
    }

    if (this.title.wrapper) {
      const wrapper = this.renderer.createElement(this.title.wrapper.element);

      this.renderer.appendChild(wrapper, name);
      this.renderer.appendChild(li, wrapper);
    } else {
      this.renderer.appendChild(li, name);
    }
    this.renderer.appendChild(nativeElement, li)
  }
}

export const APP_SIDEBAR_NAV = [
  AppSidebarNavComponent,
  AppSidebarNavDropdownComponent,
  AppSidebarNavItemComponent,
  AppSidebarNavLinkComponent,
  AppSidebarNavTitleComponent
];



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/components/app-sidebar-nav/app-sidebar-nav.component.ts